const formatResultDate = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const Race17Result = ({
  resultData
}) => {

  return (
    <div id="ResultsData" class="tabcontent" style={{ display: "block" }}>
      <div class="left-content" style={{ marginRight: "5px", marginLeft: "5px" }}>
        {resultData &&
          resultData.length > 0 &&
          resultData.map((dataObj, index) => {
            //let card = dataObj.c1;
            //let imgval1 = `/assets/images/cards/${dataObj.c1}.png`;

            let win1 = 'LOSER';
            let win2 = 'LOSER';

            let imgVal1 = '';
            let imgVal2 = '';
            let imgVal3 = '';
            let imgVal4 = '';
            let imgVal5 = '';

            if (dataObj.result == 1) {
              win1 = 'WINNER';
            }
            if (dataObj.is_any_zero == 1) {
              win2 = 'WINNER';
            }

            let bgCls1 = (win1 == 'WINNER') ? 'bgwinner' : 'bgLoser';
            let bgCls2 = (win2 == 'WINNER') ? 'bgwinner' : 'bgLoser';

            let tdCls1 = (win1 == 'WINNER') ? 'TdResultsWin' : '';
            let tdCls2 = (win2 == 'WINNER') ? 'TdResultsWin' : '';

            if (dataObj.c1) {
              imgVal1 = `/assets/images/cards/${dataObj.c1}.svg`;
              //imgVal1 = '<img src="'.$img.'" loading="lazy" style="width: 40px; height: 60px; object-fit: cover; border-radius: 5px;">';
            }
            if (dataObj.c2) {
              imgVal2 = `/assets/images/cards/${dataObj.c2}.svg`;
              //imgVal2 = '<img src="'.$img.'" loading="lazy" style="width: 40px; height: 60px; object-fit: cover; border-radius: 5px;">';
            }
            if (dataObj.c3) {
              imgVal3 = `/assets/images/cards/${dataObj.c3}.svg`;
              //imgVal3 = '<img src="'.$img.'" loading="lazy" style="width: 40px; height: 60px; object-fit: cover; border-radius: 5px;">';
            }
            if (dataObj.c4) {
              imgVal4 = `/assets/images/cards/${dataObj.c4}.svg`;
              //imgVal4 = '<img src="'.$img.'" loading="lazy" style="width: 40px; height: 60px; object-fit: cover; border-radius: 5px;">';
            }
            if (dataObj.c5) {
              imgVal5 = `/assets/images/cards/${dataObj.c5}.svg`;
              //imgVal5 = '<img src="'.$img.'" loading="lazy" style="width: 40px; height: 60px; object-fit: cover; border-radius: 5px;"">';
            }

            return (
              <div
                class="card"
                style={{
                  border: "1px solid rgb(204, 204, 204)",
                  borderRadius: "8px",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                  marginBottom: "5px",
                  background: "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                  color: "white"
                }}
              >
                <div
                  class="card-header"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px",
                    marginTop: "10px",
                    marginLeft: "7px",
                    background: "transparent",
                    borderBottom: "solid 1px #0000002a"
                  }}
                >
                  {formatResultDate(dataObj.evt_od)} - <b>ID=</b> {dataObj._id}
                </div>
                <div class="card-body">
                  <div
                    class="players-table"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>

                        <tr
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly",
                            background: "transparent"
                          }}
                        >
                          <td className={`TdResults ${tdCls1}`}>
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                Race To 17
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                <img
                                  src={imgVal1}
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                                <img
                                  src={imgVal2}
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                                <img
                                  src={imgVal3}
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                                <img
                                  src={imgVal4}
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />

                                <img
                                  src={imgVal4}
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className={`player-status ${bgCls1}`}
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {win1}
                              </div>
                            </div>
                          </td>
                          <td className={`TdResults ${tdCls2}`}>
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                Any Zero Card
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                <img
                                  src="/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg"
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className={`player-status ${bgCls2}`}
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {win2}
                              </div>
                            </div>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}


      </div>
    </div>
  );
}

export default Race17Result;